import { ContentfulCallout } from '@jbhi-fi/apis/src/contentful/types';
import { CalloutProps } from '../../Callout/Callout';
import { AssetTransformer } from './AssetTransformer';

export class CalloutTransformer {
  static toCalloutProps = (entry: ContentfulCallout): CalloutProps => {
    return {
      heading: entry.fields?.heading ?? '',
      body: entry.fields?.body,
      leftAnchorImage: entry.fields?.leftAnchorImage
        ? AssetTransformer.toContentfulImageProps(entry.fields?.leftAnchorImage)
        : undefined,
      secondaryImage: entry.fields?.secondaryImage
        ? AssetTransformer.toContentfulImageProps(entry.fields?.secondaryImage)
        : undefined,
    };
  };
}
